<template>
  <div class="traffic_notification" v-if="loading">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="select">
        <label> {{ translate('tariffication.client_name') }} </label>
        <tree-select
            :options="client_list"
            :multiple="false"
            v-model="filter.client_id"
            :placeholder="translate('tariffication.client_name')"
            :clearable="false"
        />
      </div>

      <div class="select">
        <fg-input
            type="text"
            v-model="filter.fid"
            :placeholder="translate('tariffication.device_fid')"
            :label="translate('tariffication.device_fid')"
            @keydown="restrict_chars($event)"
            @keydown.enter="get_traffic_notification"
            @focusout="get_traffic_notification"
        />
      </div>

      <div class="select" v-if="$store.getters.getPermissions.permissionGod === true">
        <label> {{ translate('tariffication.type') }} </label>
        <tree-select
            :options="type_list"
            :multiple="false"
            v-model="filter.type"
            :placeholder="translate('tariffication.type')"
            :clearable="false"
        />
      </div>

      <div class="checkboxs">
        <div class="filter checkbox">
          <div class="info">
            {{ translate('tariffication.active') }}
          </div>
          <label class="switch" @click.prevent="bool_active = !bool_active">
            <input type="checkbox" v-model="bool_active">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <div class="button">
        <span
            class="btn btn-warning text-center"
            @click.prevent="clear_filter()"
        >
            {{ translate('filter.reset') }}
        </span>
      </div>
    </div>

    <div class="response_table">
      <table v-if="notifications.length > 0">
        <thead style="flex: 0">
          <tr>
            <th scope="col" v-if="$store.getters.getPermissions.permissionGod === true">
              {{ translate('device_traffic_alert.type') }}
            </th>
            <th scope="col">
              {{ translate('device_traffic_alert.device_name') }}
            </th>
            <th scope="col">
              {{ translate('device_traffic_alert.device_fid') }}
            </th>
            <th scope="col">
              {{ translate('device_traffic_alert.device_group') }}
            </th>
            <th scope="col">
              {{ translate('device_traffic_alert.client_name') }}
            </th>
            <th scope="col">
              {{ translate('device_traffic_alert.active') }}
            </th>
            <th scope="col">
              {{ translate('device_traffic_alert.emails') }}
            </th>
            <th scope="col">
              {{ translate('device_traffic_alert.last_notification_time') }}
            </th>
            <th scope="col">
              {{ translate('device_traffic_alert.ts_last_check') }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(notification, key) in notifications"
            :key="key"
            class="device"
          >
            <td :data-label="translate('device_traffic_alert.type')" v-if="$store.getters.getPermissions.permissionGod === true">
              {{ notification.type }}
            </td>
            <td :data-label="translate('device_traffic_alert.device_name')">
              {{ notification.device_name }}
            </td>
            <td :data-label="translate('device_traffic_alert.device_fid')">
              <router-link :to="'/device/' + notification.device_fid">
                {{ notification.device_fid }}
              </router-link>
            </td>
            <td :data-label="translate('device_traffic_alert.device_group')">
              {{ notification.device_group }}
            </td>
            <td :data-label="translate('device_traffic_alert.client_name')">
              <router-link :to="'/client/' + notification.client_id">
                {{ notification.client_name }}
              </router-link>
            </td>
            <td :data-label="translate('device_traffic_alert.active')">
              {{ notification.active }}
            </td>
            <td :data-label="translate('device_traffic_alert.emails')">
              {{ notification.emails }}
            </td>
            <td :data-label="translate('device_traffic_alert.last_notification_time')">
              {{ get_date(notification.ts_rate_alert_send) }}
            </td>
            <td :data-label="translate('device_traffic_alert.ts_last_check')">
              {{ get_date(notification.ts_last_check) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="loading" v-else>
    <div class="spinner">
      <scale-loader />
    </div>
  </div>
</template>

<script>

export default {
  name: 'traffic_notification',
  components: {
    // TextTable
  },
  data () {
    return {
      loading: false,
      notifications: {},
      filter: {
        client_id: "",
        fid: "",
        type: "",
        active: 1
      },
      bool_active: true,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },
  computed: {
    client_list() {
      let list = [{id: '', label: 'All clients'}]
      let clients = this.$store.getters.getClientsList.map((client) => {
        return {id: client.id, label: client.name}
      })
      return list.concat(clients)
    },
    type_list() {
      return [
        {id: "", label: "All"},
        {id: "sim", label: "Simcards"},
        {id: "tariffication", label: "Tariffication"}
      ]
    },
  },
  watch: {
    filter: {
      deep: true,
      handler(){
        if (this.$route.name === 'notification_section'){
          let string = '?'
          for (let key in this.filter) {
            if (this.filter[key]) string += '&' + key + '=' + this.filter[key]
          }
          history.pushState(null, null, this.$route.path + string)
        }
      }
    },
    'filter.client_id': {
      deep: false,
      handler(new_val) {
        if (new_val !== undefined) {
          this.get_traffic_notification()
        }
      }
    },
    'filter.type': {
      deep: false,
      handler() {
        this.get_traffic_notification()
      }
    },
    bool_active:{
      deep: false,
      handler(new_val){
        this.filter.active = new_val === true ? 1 : null
        this.get_traffic_notification()
      }
    }
  },
  created () {
    this.check_query()
  },
  activated () {
    this.check_query()
  },
  methods: {
    clear_filter(){
      this.filter =  {
        client_id: null,
        fid: '',
        active: null
      }
      this.bool_status = false
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          if (Object.keys(this.filter).indexOf(key) > -1){
            this.filter[key] =  this.$route.query[key]
          }
        }
      }
      this.get_traffic_notification()
    },
    get_traffic_notification(){
      let data = {}
      Object.keys(this.filter).forEach((key) => {
        if (this.filter[key]) data[key] = this.filter[key]
      })

      this.$http.v1.getDeviceTrafficAlerts(data, (response) => {
        this.notifications = response.data
        this.loading = true
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}

</script>

<style lang='scss' scoped>
.traffic_notification{
  display: flex;
  flex-direction: column;
  padding-top: 30px;
  .header{
    display: flex;
    align-content: center;
    justify-content: space-between;
    flex: 1;
    .select{
      width: 50%;
    }
    .checkboxs{
      width: 50%;
      display: flex;
      align-content: center;
      justify-content: space-between;
      .checkbox {
        width: 50%;
        margin: 0;
        min-width: auto;
      }
    }
    .button{
      display: flex;
      align-content: center;
      justify-content: center;
      flex-direction: column;
      .btn{
        padding: 0 5px;
        margin-bottom: 5px;
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
  }
  .response_table{
    padding-right: 0;
    padding-left: 0;
    padding-top: 0;
    flex: 10;
  }
  table{
    font-size: 14px;
    line-height: 120%;
    tbody{
      tr{
        th, td{
          font-size: 12px;
        }
      }
    }
  }
}






</style>
